import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { LocalStorageRefService } from './local-storage-ref.service';

@Injectable({
  providedIn: 'root'
})
export class BaseLocalStorageService {

  private _myData$ = new BehaviorSubject<any>(null)
  private _localStorage!: Storage;
  public myData$ = this._myData$.asObservable()

  constructor(private _localStorageRefService: LocalStorageRefService){
    this._localStorage = _localStorageRefService.localStorage
  }

  public setInfo(data: any) {
    const jsonData = JSON.stringify(data)
    localStorage.setItem('myData', jsonData)
    this._myData$.next(data)
  }

  public getInfo(storageString: string = 'lastCheckedList') {
   // console.log('now calling base getinfo for localStorageService');
    if ((storageString != undefined) && (storageString != null)){
      const strStorageLocation: string = storageString !== null ? storageString: '';
     // console.log("strStorageLocation:" + strStorageLocation)
      try
      {
        const jsonStr = this._localStorage.getItem(strStorageLocation) ? this._localStorage.getItem(strStorageLocation) : '';
        const data = JSON.parse(jsonStr ? jsonStr : '');
        // console.log('working off of localStorage data:' + data)
        return data; //this._myData$.next(data);
      }
      catch (Err)
      {
      // console.log('Error caught while loading localStorage:' + Err)
        return '';
      }
    }
    else {return ''}
  }
 
  clearInfo() {
    localStorage.removeItem('myData')
    this._myData$.next(null)
  }

  clearAllLocalStorage() {
    localStorage.clear()
  //  this.myData$.next(null)
  }

  removeItem(key: string)
  {
    localStorage.removeItem(key);
  }
}
